import createCache from 'services/createCache';

export default createCache({
	onCancel: null,
	onOk: null,
});
